import { useRouter } from "app/tools/router/hooks/useRouter";
import { AxiosError } from "axios";
import { useRouterSettings } from "src/routerSettings";

import { tryLogin } from "../../api/tryLogin/endpoint";
import { useAuthTokenContext } from "../context";

export const useAuthStore = () => {
  const router = useRouter();
  const routerSettings = useRouterSettings();
  const authContext = useAuthTokenContext();

  const login = async (username: string, password: string) => {
    try {
      const response = await tryLogin(username, password);
      authContext?.authenticate(response.data.token);
      router.push(routerSettings.defaultRoute);
    } catch (error) {
      if (error instanceof AxiosError && error.status === 401) {
        return { error: "Špatné přihlašovací údaje." };
      } else {
        return { error: "Neznámá chyba." };
      }
    }
  };

  return {
    login,
    logout: authContext?.logout,
  };
};
